import moment from 'moment-timezone';

const dayFmt = 'YYYY-MM-DD';

const sortMatchesByMatchTime = (matchesArray) => [...matchesArray].sort((a, b) => {
    if (moment(a.date).isBefore(b.date)) {
        return -1;
    }
    if (moment(a.date).isAfter(b.date)) {
        return 1;
    }
    return 0;
});

export const sortMatchesWithLocation = (matchesArray) => {
    const { withLocation, withoutLocation } = matchesArray.reduce((acc, match) => {
        if (match.locationId) {
            acc.withLocation.push(match);
        } else {
            acc.withoutLocation.push(match);
        }
        return acc;
    }, { withLocation: [], withoutLocation: [] });

    return [
        ...sortMatchesByMatchTime(withLocation),
        ...sortMatchesByMatchTime(withoutLocation),
    ];
};

const dayInEvent = (isoUtcString, eventTimeZone) => {
    const m = moment.utc(isoUtcString);
    return (eventTimeZone ? m.tz(eventTimeZone) : m).format(dayFmt);
};

export const filterMatchesByDate = (matchesArray, dayStr, eventTimeZone) => {
    return matchesArray.filter(match => dayInEvent(match.date, eventTimeZone) === dayStr);
};

export const filterMatchesByFacility = (matchesArray, facilityName) => {
    return matchesArray.filter(match => match.facilityName === facilityName);
};

export const filterMatchesByDraw = (matchesArray, drawId, drawsDict) => matchesArray.filter(match => {
    const matchDraw = drawsDict[match.drawId];
    return matchDraw.parentDrawId === drawId || matchDraw.id === drawId;
});
